// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-17efe3b4] {\n  margin-bottom: 4rem;\n}\n.select[data-v-17efe3b4] {\n  margin-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
